const boldedElements = [
  `<b>Watchlist</b>`,
  `<b>edit</b>`,
  `<b>Add a Channel</b>`,
  `<b>Save</b>`,
  `<b>Subscribe</b>`,
  `<b>Manage</b>`,
  `<b>Bookmark</b>`,
];

const troubleshootingArray = [
  {
    id: 1,
    title: "Can I delete a chat post?",
    content:
      "Chat posts can be edited or deleted within a 15-minute window after posting. After this, they cannot be edited further or deleted and will remain on the channel and your profile page.",
  },
  {
    id: 2,
    title: "How do I add channels to my watchlist?",
    content: `You can add channels to your watchlists through the Watchlist tab on the CEO homepage or directly from the stock channel.`,
    secondaryContent: [
      {
        heading: "Adding Through the Watchlist Tab:",
        content: `
          <ol>
            <li>Go to the Watchlist tab on the CEO homepage.</li>
            <li>Click <b>Edit</b> and then <b>Add a Channel.</b></li>
            <li>Enter the name or ticker of the stock you want to add</li>
            <li>Click <b>Save</b> at the top of the screen.</li>
          </ol>
        `,
      },
      {
        heading: "Adding Through a Stock Channel:",
        content: `
          <ol>
            <li>Navigate to a stock channel you want to add to your watchlist.</li>
            <li>In the top right corner, open the <b>Subscribe</b> dropdown menu.</li>
            <li>Choose the category and add it to your desired watchlist.</li>
          </ol>
        `,
      },
    ],
  },
  {
    id: 3,
    title: "How do I use the tagging feature?",
    content:
      "The hashtag (#) lets you categorize information relevant to specific topics on CEO.CA. You can include these tags in your posts which will link to new channels. Clicking on a hashtag lets you view all posts that have been tagged with that specific keyword.",
  },
  {
    id: 4,
    title: "Why does some text appear smaller?",
    content:
      "Posts that have been flagged by many users will have their text reduced.",
  },
  {
    id: 5,
    title: "Can I bookmark other user’s posts?",
    content: `Yes, simply click on the post you want to bookmark, and a dropdown will appear. Under the ${boldedElements[5]} category, click the ${boldedElements[6]} button and the message will be saved to your bookmarks.`,
  },
  {
    id: 6,
    title: "When is short data released and posted on CEO.CA?",
    content:
      "Short data is generated on the 15th and last day of each month. Investment Dealers have three business days (T+3) to report short positions to IIROC, after which IIROC posts the consolidated reports on the fourth business day (T+4) on CEO.CA.",
  },
  {
    id: 7,
    title: "Using Reply Threads",
    content:`
      Replying to a post on CEO.CA is intuitive and enhances the discussion experience. Here's how you can use the reply threads:
      <ol>
        <li><b>Expand the Post:</b> Navigate to any post you wish to reply to on CEO.CA. Click on the post to expand it, which will reveal additional options.</li>
        <li><b>Initiate a Reply:</b> The first button you'll see is an arrow pointing left, labeled 'Reply'. Click this button to open a text box for your response.</li> 
        <li><b>Compose and Post Your Reply:</b> Write your reply in the text box. Once you post it, your reply will appear in the chat room. The original message you're replying to will be displayed above your reply for context.</li> 
        <li><b>View Original Message:</b> If you or other users want to read the original message in full, simply click on it. This will automatically scroll up to where it was originally posted in the chat room.</li> 
      </ol>
      This feature makes it easy to follow conversations and engage with specific comments, enhancing your interaction on CEO.CA.
    `
  },
];

export default troubleshootingArray;
